import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"

const NotificationsPage = loadable(
  async () => import("~/features/notifications/pages/NotificationsPage"),
  { fallback: <></> },
)

export const notificationRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.notifications,
    element: <NotificationsPage />,
  },
]
